import { useState } from 'react';
import {GrClose} from 'react-icons/gr';
import { MdDeleteSweep, MdEdit} from 'react-icons/md';

const ExpandNote=(props)=>{
    
    
    const [noteText, setNoteText] = useState(props.note.body);
    const [charCount, setCharCount] = useState(noteText.length);
    const [wordCount, setWordCount] = useState(noteText.trim().split(/\s+/).length);
    const [edit, setEdit] = useState(props.isEdit);
    
    
    const EditText =()=>{
        if(edit==false)
        return(<p className="note-p-textspace">{noteText}</p>);
        else
        return(<textarea placeholder="Add a new note" value={noteText} onChange={changeHandler}/>)
    }
    
    
    const EditFooter =()=>{
        if(edit==false)
        return(
                <>
                <small>{props.note.updated_at}</small>
                <div>
                    <MdEdit className="edit-icon-expanded" style={{marginRight:"30px"}} onClick={()=>{setEdit(true)}}/>
                    <MdDeleteSweep className="delete-icon" onClick={props.deleteHandler}/>
                </div>
                </>
        );
        else
        return(
            <>
                <small>{props.countPreference=='word'?wordCount:charCount}</small>
                <button className="saveBtn" onClick={saveHandler}>Save</button>
            </>
        )
    }


    const changeHandler =(event)=>
    {
        setNoteText(event.target.value);
        setCharCount(noteText.length+1);
        setWordCount(noteText.trim().split(/\s+/).length)
    }

    const saveHandler=()=>{

        let date= new Date;
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const editedNote = 
        {
            id:props.note.id,
            text: noteText,
            // date: day+"/"+month+"/"+year
        }
        props.editHandler(editedNote);
        setEdit(!edit);
    }
    
    return(
        <>
            <div className="backdrop" onClick={props.onClose}></div>
            <div className="note expanded">
                <GrClose className="close-icon" onClick={props.onClose}/>
            <div className="noteText" onClick={()=>{setEdit(true);}}>
            {
                EditText()
            }
            </div>
                
                <div className="note-footer">
                    {
                        EditFooter()
                    }
                </div>
            </div>
        </>
    );
}

export default ExpandNote;